import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

export const getTasks = async (fromDate, toDate, workerId) => {
  const data = await request.get(
    `/Request/get_tasks`,
    { fromDate, toDate, workerId },
    'При загрузке задач произошла ошибка',
    []
  );
  return data;
};

const useTasks = (params = {}, options = {}) => {
  const { fromDate, toDate, workerId } = params;

  return useQuery(
    getQueryKeys.tasks({ fromDate, toDate, workerId }),
    () => getTasks(fromDate, toDate, workerId),
    options
  );
};

export default useTasks;
